import { useParams } from 'react-router-dom';

import Resultados from '../Components/Main/Resultados';
import MiniCursoVero from './MiniCursoVero/MiniCursoVero';
import Fit12Page from './Fit12/Fit12Page';

const ProductDetail: React.FC = () => {

  const { id } = useParams();

  switch (id) {
    case '2':
      return (
        <div className="my-[20px]">
          <Resultados loading_timeProp={0} />
        </div>
      );
    case '24':
      return (
        <div className="my-[20px]">
          <MiniCursoVero productId={24} />
        </div>
      );
    case '26':
      return (
        <div className="my-[20px]">
          <Fit12Page productId={26} />
        </div>
      );
    default:
      return (
        <div className="mx-1 my-5">Proximamente</div>
      );
  }
};

export default ProductDetail;
